import { ErrorOutlineOutlined } from "@mui/icons-material";
import { Grid, Typography } from "@mui/material";
import React from "react";

export default function ErrorPage() {
  return (
    <div
      style={{
        width: "85%",
        textAlign: "center",
        margin: "5rem auto 10rem auto",
      }}
    >
      <Grid container direction="column">
        <Grid item>
          <Typography variant="h2">Error de Carga</Typography>
        </Grid>
        <Grid
          item
          display="flex"
          alignItems="center"
          gap={1}
          sm={4}
          justifyContent="center"
        >
          <ErrorOutlineOutlined color="primary" sx={{ fontSize: "32px" }} />
          <Typography variant="h4">
            Revisa tu conexión a internet e inténtalo nuevamente.
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}
